export default __webpack_public_path__ + "static/1-1f8e70ddff1be682c163dfa1a1126a03.png";